module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/assessment-charts/summary-scales-chart/summary-scales-chart.component.css
// module id = ./src/app/assessment-charts/summary-scales-chart/summary-scales-chart.component.css
// module chunks = main